import { Theme } from '@mui/material/styles/createTheme'
import React from 'react'
import { Typography, useMediaQuery, Stack } from '@mui/material'
import { Law } from './Law'
import { useTranslation } from '../../hooks/helper/useTranslation'

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'

interface Props {
  isFooterOpen: boolean
  setIsFooterOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ClosedFooter: React.FC<React.PropsWithChildren<Props>> = ({
  isFooterOpen,
  setIsFooterOpen,
}) => {
  const { t } = useTranslation()
  const mdUp = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'))

  return (
    <Stack direction="row" alignItems="center" gap={2} flex={1} ml="auto">
      <Law />
      {mdUp && (
        <Typography ml={1} variant="body2">
          {t('footer:rights')}
        </Typography>
      )}

      {!isFooterOpen && (
        <Stack
          justifyContent="center"
          alignItems="center"
          onClick={() => setIsFooterOpen(true)}
          sx={{ cursor: 'pointer' }}
          ml={2}
        >
          <KeyboardArrowUpIcon />
        </Stack>
      )}
    </Stack>
  )
}
